/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_View_IssueInputs */



/**
* | output |
* | --- |
* | "View on GitHub →" |
*
* @param {Feedback_View_IssueInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_view_issue = /** @type {((inputs?: Feedback_View_IssueInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_View_IssueInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir sur GitHub →")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver en GitHub →")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ver no GitHub →")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza su GitHub →")
	return /** @type {LocalizedString} */ ("View on GitHub →")
});